<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-card
      outlined
      class="pa-2">
      <v-row 
        align="center"
        justify="end">
        <v-col
          cols="12" 
          md="8"
          class="pt-5 pb-7">
          <div
            class="d-flex align-center">
            <div>
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.hadir"
                type="text">
                <div
                  class="body-2">
                  <span
                    style="opacity: 60%;">
                    Pegawai Presensi (Hari Ini):
                  </span>
                  
                  <strong>{{ count.hadir }}</strong>
                </div>
              </v-skeleton-loader>
            </div>

            <div
              class="ml-16">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.ijin"
                type="text">
                <div
                  class="body-2">
                  <span
                    style="opacity: 60%;">
                    Pegawai Ijin (Hari Ini):
                  </span>
                  
                  <strong>{{ count.ijin }}</strong>
                </div>
              </v-skeleton-loader>
            </div>
          </div>
        </v-col>

        <v-col 
          cols="12" 
          md="4"
          class="pt-5 pb-7">
          <v-text-field
            filled
            rounded
            dense
            single-line
            hide-details
            :color="set_color"
            placeholder="Cari . . ."
            vvvv-uppercase
            append-icon="mdi-magnify"
            clearable
            v-model="search"
            @click:clear="search = ''; fetch();"
            v-on:keyup.enter="fetch()"
            style="border-radius: 10px;">
          </v-text-field>
        </v-col>
      </v-row>
      
      <gmap-map
        ref="gmap"
        :center="center"
        :zoom="12"
        :scrollwheel="false"
        style="width:100%; height: calc(100vh - 210px);">

        <gmap-marker
          v-for="(item, index) in list.markers"
          :key="index"
          :position="item.latlng"
          :icon="item.icon"
          @click="toggleInfoWindow(item, index)">
        </gmap-marker>

        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false">
          <div v-html="infoContent"></div>
        </gmap-info-window>
      </gmap-map>
    </v-card>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import firebase from "firebase";
  import moment from 'moment';
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },
        dateNow: moment().format('YYYY-MM-DD'),
        search: '',
        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        selected: {
          all: []
        },
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },
        count: {
          hadir: 0,
          ijin: 0
        },
        list: {
          data: [],
          markers: []
        },
        pagination: {
          data: {}
        },
        process: {
          load: false,
          hadir: false,
          ijin: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      set_color () {
        return this.$store.state.color
      }
    },
    created() {
      let ref = firebase.firestore().collection('routes')
      ref.onSnapshot(snapshot => {
        this.fetch()
      })
    },
    mounted () {
      this.fetchHadir()
      this.fetchIjin()
    },
    methods: {
      async fetch () {
        this.process.load = true
        
        let params = {
          limit: 100000,
          'date[eq]': this.dateNow,
          search: this.search
        }

        this.selected.all = []
        this.list.markers = []

        await get(`admin/attendance`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.list.data = res.results.data
            this.pagination.data = res.results.pagination
            
            if (this.pagination.data.total_data > 0) {
              this.list.data.map((obj) => {
                this.selected.all.push(obj)
              })

              this.fetchCheck()
            } else {
              this.dialog.snackbar = this.search.length > 0 ? true : false
              this.message.success = this.search.length > 0 ? 'Data yang anda cari tidak ditemukan.' : ''
            }
          }
        })
      },
      async fetchCheck () {
        let data = this.selected.all

        for (let i = 0; i < data.length; i++) {
          let ref = firebase.firestore().collection('routes').where('user_id', '==', data[i].user_id)
          await ref.onSnapshot(snapshot => {
            if (snapshot.docChanges().length > 0) {
              if (snapshot.docChanges()[0].type === 'added') {
                let id = snapshot.docs.map((doc) => {
                  return doc.id
                })

                console.log(id[0])
                
                this.fetchRoute(id[0])
              } else {
                this.list.markers = []

                this.fetch()
              }
            }
          })
        }
      },
      async fetchRoute (id) {
        let ref = firebase.firestore().collection('routes').doc(id).collection('user').orderBy('input_datetime', 'asc')
        await ref.onSnapshot(snapshot => {
          if (snapshot.docChanges().length > 0) {
            let data = snapshot.docs.map((doc) => {
              return {
                id: doc.data().id,
                code: doc.data().code,
                name: doc.data().name,
                username: doc.data().username,
                email: doc.data().email,
                mobilephone: doc.data().mobilephone,
                address: doc.data().address,
                image_url: doc.data().image_url,
                position: doc.data().position,
                role: doc.data().role,
                unit_id: doc.data().unit_id,
                unit_name: doc.data().unit_name,
                latitude: doc.data().latitude,
                longitude: doc.data().longitude,
                input_datetime: doc.data().input_datetime
              }
            })

            this.insertMarker(data)
          } else {
            this.list.markers = []
          }
        })
      },
      insertMarker (data) {
        this.$gmapApiPromiseLazy().then(() => {
          this.list.markers.push({
            id: data[data.length - 1].id,
            code: data[data.length - 1].code,
            name: data[data.length - 1].name,
            username: data[data.length - 1].username,
            email: data[data.length - 1].email,
            mobilephone: data[data.length - 1].mobilephone,
            address: data[data.length - 1].address,
            image_url: data[data.length - 1].image_url,
            position: data[data.length - 1].position,
            role: data[data.length - 1].role,
            unit_id: data[data.length - 1].unit_id,
            unit_name: data[data.length - 1].unit_name,
            latitude: data[data.length - 1].latitude,
            longitude: data[data.length - 1].longitude,
            input_datetime: data[data.length - 1].input_datetime,
            latlng: {
              lat: parseFloat(data[data.length - 1].latitude), 
              lng: parseFloat(data[data.length - 1].longitude)
            },
            icon: {
              url: require('@/assets/image/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.list.markers.length > 0 ? this.list.markers[this.list.markers.length - 1].latlng : this.center
        })

      },
      toggleInfoWindow (marker, idx) {
        this.infoWindowPos = marker.latlng
        this.infoContent = this.getInfoWindowContent(marker)
        
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      getInfoWindowContent (marker) {
        let data = marker

        data.image_url = data.image_url === '' ? require('@/assets/image/member_default.jpg') : data.image_url

        return (`
          <div id="iw-container">
            <div class="iw-title">
              Lokasi Terakhir
            </div>

            <div class="iw-content">
              <img 
                class="image"
                height="100" 
                width="100"
                src="${data.image_url}">

              <div class="iw-subTitle" style="margin-bottom: 10px;">
                ${data.name}
              </div>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Email
              </p>

              <p style="margin-bottom: 14px; font-weight: bold;">
                ${data.email}
              </p>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Telepon
              </p>

              <p style="margin-bottom: 14px; font-weight: bold;">
                ${data.mobilephone}
              </p>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Unit
              </p>

              <p style="margin-bottom: 14px; font-weight: bold; text-transform: capitalize;">
                ${data.unit_name}
              </p>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Role (Posisi)
              </p>

              <p style="font-weight: bold; text-transform: capitalize;">
                ${data.role} (${data.position})
              </p>
            </div>
          </div>
        `)
      },

      async fetchHadir () {
        this.process.hadir = true

        let params = {
          'date[eq]': this.dateNow,
          status: 'hadir'
        }

        await get(`admin/attendance`, { params })
        .then(response => {
          let res = response.data

          this.process.hadir = false

          if (res.status === 200) {
            this.count.hadir = res.results.pagination.total_data
          }
        })
      },
      async fetchIjin () {
        this.process.ijin = true

        let params = {
          'date[eq]': this.dateNow,
          status: 'ijin'
        }

        await get(`admin/attendance`, { params })
        .then(response => {
          let res = response.data

          this.process.ijin = false

          if (res.status === 200) {
            this.count.ijin = res.results.pagination.total_data
          }
        })
      }
    }
  }
</script>